import { render } from "./ResetPassword.vue?vue&type=template&id=32b75a6a"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"
script.render = render

export default script